import { getPageData, getPages, getLayoutData } from '../api/api';

export default function Page() {
	return null; // KUBA ZEPSUŁ
	// const technologyOrToolName = data?.projectTechnologyName || '';
	// return (
	// 	<div className="px-main">
	// 		<h1 style={{ position: 'relative' }}>{technologyOrToolName}</h1>
	// 	</div>
	// );
}

const PAGE_CONTENT_TYPE = 'allProjectTechnologies';

const pathsQuery = `
query GetSingleTechnologyOrTool($locale: SiteLocale) {
	${PAGE_CONTENT_TYPE}(locale: $locale, first: 100) {
        projectTechnologyName
        slug
	}
}
`;

const propsQuery = `
	query GetTechnologyOrTool($slug: String, $locale: SiteLocale) {
        ${PAGE_CONTENT_TYPE}(locale: $locale, filter: { slug: { eq: $slug }}) {
            projectTechnologyName
            slug
        }
	}
`;

export async function getStaticProps({ params, locale }) {
	const { slug } = params;
	const data = await getPageData(PAGE_CONTENT_TYPE, slug, propsQuery, locale);
	const { globals, cookies, menu, footer } = await getLayoutData(locale);
	return {
		props: {
			data,
			globals,
			cookies,
			locale,
			menu,
			footer,
		},
		revalidate: 120,
	};
}

export async function getStaticPaths({ locales }) {
	const paths = [];
	for (const locale of locales) {
		const projectPosts = await getPages(PAGE_CONTENT_TYPE, pathsQuery, locale);
		const posts = projectPosts.map((page) => ({
			params: {
				slug: page.slug,
			},
			locale,
		}));
		paths.push(...posts);
	}
	// { fallback: false } means other routes should 404.
	return {
		paths,
		fallback: false,
	};
}
